"use client";

import NextError from "next/error";
import { useEffect } from "react";
import { reportPlaceTelemetryError } from "@/lib/telemetry/place-telemetry";

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    console.error("[GlobalError]", error);
    // 화면 전체가 오류 화면으로 바뀐 경우 — 가장 심각한 에러라 텔레메트리로도 보낸다.
    reportPlaceTelemetryError(error, { source: "react", handled: false, digest: error.digest });
  }, [error]);

  return (
    <html data-imp="app/global-error.tsx:15:5">
      <body data-imp="app/global-error.tsx:16:7">
        {/* `NextError` is the default Next.js error page component. Its type
        definition requires a `statusCode` prop. However, since the App Router
        does not expose status codes for errors, we simply pass 0 to render a
        generic error message. */}
        <NextError data-imp-o="app/global-error.tsx:21:9" statusCode={0} />
      </body>
    </html>
  );
}